import { isValidPhoneNumber } from 'react-phone-number-input';

import i18n from '../providers/Locale';
import { EMAIL_REGEXP } from '../shared/regexp';

export type ValidationType = {
	isValid: boolean;
	message: string;
};

export const validateEmail = (email?: string, isRequired?: boolean): ValidationType => {
	const result: ValidationType = { isValid: true, message: '' };

	if (!email && isRequired) {
		result.isValid = false;
		result.message = i18n('required_field') as string;
	} else if (email && !EMAIL_REGEXP.test(email)) {
		result.isValid = false;
		result.message = i18n('incorrect_email') as string;
	}

	return result;
};

export const validateRequiredField = (value?: string): ValidationType => {
	const result: ValidationType = { isValid: true, message: '' };

	if (!value) {
		result.isValid = false;
		result.message = i18n('required_field') as string;
	}

	return result;
};

export const validatePhoneNumber = (phone?: string): ValidationType => {
	const result: ValidationType = { isValid: true, message: '' };

	if (!phone) {
		result.isValid = false;
		result.message = i18n('required_field') as string;
	} else if (!isValidPhoneNumber(phone || '')) {
		result.isValid = false;
		result.message = i18n('incorrect_phone') as string;
	}

	return result;
};
